export function formatString(value: string, length: number = 20) {
  if (value.length > length) {
    return value.slice(0, length);
  }
  return value;
}
